import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  server_name: "",
  server_id: -1,
  ButtonsArray: [],
  Extra_Destinations_Array: [],
  CarTypesArray: [],
  Code_for_POS: 0,
  Car_Type_Code_To_Show_Hotel: 0,
  Email_To_Inform: "",
  ShowPrices: true,
  currencySymbol: "€",
  ShowBanner: true,
  Refresh_Calls_Seconds: 30,
  Use_Here_Maps: false,
  Use_Custom_Map_Key: false,
  Map_Key: "",
  currentPage: "",
  ShowPOS: false,
};

export const applicationSettings = createSlice({
  name: "applicationSettings",
  initialState: {
    value: initialStateValue,
  },
  reducers: {
    redux_applicationSettings: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    redux_resetapplicationSettings: (state) => {
      state.value = initialStateValue;
    },
  },
});
export const { redux_applicationSettings, redux_resetapplicationSettings } =
  applicationSettings.actions;

export default applicationSettings.reducer;
